export enum UserRole {
  USER = "user",
  GUEST = "guest",
}

export enum AdminRole {
  REALTOR = "realtor",
  ADMIN = "admin",
  SUPER_ADMIN = "super_admin",
  MAIN_REALTOR = "main_realtor",
  SECRETARY = "secretary",
}
